import moment from 'moment';

export default function (value, format) {
    if (value) {
        return moment(value).format(format);
    }
    return ''
}
